import { combineReducers, Reducer, ReducersMapObject } from 'redux';
import { IStoreState } from '../store/StoreState';

import { reducer as toastrReducer } from '@ane/legacy/lib/components/toastr/ReactReduxToastr';

import graph from './GraphReducer';
import systemHealthBannerReducer from '@ane/exp-ux/lib/components/Banners/SystemHealthBannerReducer';
import ModalReducer from './ModalReducer';
import BannerReducer from '@ane/exp-ux/lib/components/Banners/BannerReducer';
import currentUserDetailsReducersMapObject from '@ane/exp-data/lib/userDetails/CurrentUserDetailsReducer';
import GlobalConfigReducer from '@ane/exp-data/lib/globalConfig/GlobalConfigReducer';
import HelpReducer from '@ane/help-app-module/lib/module/reducers';
import experimentReducers from '@ane/experiment-app-module/lib/module/reducers';
import routeUpdateState from '@ane/core/lib/services/syncUrlAndStore/RouteUpdateReducer';
import userAccessReducersMapObject from '@ane/exp-ux/lib/components/GetUserAccess/UserAccess.reducer';

// Global
import getWorkspaceReducersMapObject from '@ane/exp-ux/lib/components/GetWorkspace/GetWorkspace.ducks';

// Exp Studio
import { moduleReducer as unifiedStudioReducer } from '@ane/unified-studio/lib/module/reducers';

// Analysis
import analysisReducers from '@ane/summary-app-module/lib/module/reducers';

// Analysis-Template
import analysisTemplateReducers from '@ane/analysis-template/lib/module/reducers';

// ExperimentSearch-Template
import AppExperimentSearchReducer from '@ane/experiment-search-app-module/lib/module/reducers';

// Tenant
import tenantReducers from '@ane/tenant/lib/module/reducers';

// TrafficFiter
import trafficFilterReducers from '@ane/trafficFilter/lib/module/reducers';

import { moduleReducer as experimentTemplateModuleReducer } from '@ane/exptemplate/lib/module/reducers';

// Srm Debug Tool
import { moduleReducer as srmDebugModuleReducer } from '@ane/srm-debug-app-module/lib/module/reducers';

import { garModuleReducer as GarModuleReducer } from '@ane/summary-app-module/lib/module/reducers';

// Extensions
import { moduleReducer as ExtensionsModuleReducer } from '@ane/extensions/lib/module/reducers';

// Flight
import { moduleReducer as flightModuleReducer } from '@ane/flight-app-module/lib/module/reducers';

// DataSource Management
import { moduleReducer as dataSourceManagementModuleReducer } from '@ane/datasource-management/lib/module/reducers';

// Budget
import { moduleReducer as budgetModuleReducer } from '@ane/budget/lib/module/reducers';

// Emergency shutdown
import { moduleReducer as emergencyShutdownReducer } from '@ane/emergency-shutdown/lib/module/reducers';

// Resolve Gate
import { moduleReducer as resolveGateReducer } from '@ane/expalert/lib/module/reducers';

// Compute Management System
import { moduleReducer as computeManagementSystemModuleReducer } from '@ane/compute-management-system/lib/module/reducers';

// Workspace settings
import { moduleReducer as workspaceSettingsModuleReducer } from '@ane/workspace-settings/lib/module/reducers';

// Hypothesis
import { moduleReducer as hypothesisModuleReducer } from '@ane/hypothesis-app-module/lib/module/reducers';

// Progressions
import { moduleReducer as progressionsModuleReducer } from '@ane/progressions-app-module/lib/module/reducers';

// Notification
import { moduleReducer as notificationModuleReducer } from '@ane/notification/lib/module/reducers';

// Assignment Unit
import assigmentUnitRootReducer from '@ane/assignment-unit-app-module/lib/module/reducers';

// Metrics authoring
import { moduleReducer as metricsAuthoringReducer } from '@ane/metrics-authoring/lib/module/reducers';

import AppAdminReducer from '@ane/admin-app-module/lib/module/reducers';
import { assignmentDetailsModuleReducer } from '@ane/exp-data/lib/assignmentDetailsV2';

// Notification Subscription
import LoadSubscribersReducersMapObject from '@ane/exp-ux/lib/components/Subscribers/LoadSubscribers.ducks';
import SetSubscribersReducersMapObject from '@ane/exp-ux/lib/components/Subscribers/SetSubscribers.ducks';

// Select ExperimentationGroup
import selectExperimentationGroupsReducersMapObject from '@ane/exp-ux/lib/components/SelectExperimentationGroup/LoadExperimentationGroups.ducks';
import LoadSubscribersReducersMapObjectV2 from '@ane/exp-ux/lib/components/Subscribers/LoadSubscribersV2.ducks';
import SetSubscribersReducersMapObjectV2 from '@ane/exp-ux/lib/components/Subscribers/SetSubscribersV2.ducks';

// API
import { rootReducer as rootApiReducer } from '@ane/exp-data/lib/redux/api';
import { authoringApi } from '@ane/exp-data/lib/redux/rtkquery/authoring';
import { xCardScorecardApi } from '@ane/exp-data/lib/redux/rtkquery/xcard';
import { notificationHubApi, notificationHubV1Api, ctmApi } from '@ane/exp-data/lib/redux/rtkquery';

const allReducers: ReducersMapObject<IStoreState, any> = {
  graph,
  toastr: toastrReducer,
  modals: ModalReducer,
  systemHealthBanner: systemHealthBannerReducer,
  banners: BannerReducer,
  ...progressionsModuleReducer,
  ...currentUserDetailsReducersMapObject,
  ...selectExperimentationGroupsReducersMapObject,
  globalConfig: GlobalConfigReducer,
  ...HelpReducer,
  ...experimentReducers,
  ...AppExperimentSearchReducer,
  ...routeUpdateState,
  ...analysisReducers,
  ...analysisTemplateReducers,
  ...tenantReducers,
  ...trafficFilterReducers,
  ...experimentTemplateModuleReducer,
  ...srmDebugModuleReducer,
  ...GarModuleReducer,
  ...ExtensionsModuleReducer,
  ...flightModuleReducer,
  ...dataSourceManagementModuleReducer,
  ...budgetModuleReducer,
  ...emergencyShutdownReducer,
  ...resolveGateReducer,
  ...computeManagementSystemModuleReducer,
  ...getWorkspaceReducersMapObject,
  ...unifiedStudioReducer,
  ...userAccessReducersMapObject,
  ...hypothesisModuleReducer,
  ...notificationModuleReducer,
  ...assigmentUnitRootReducer,
  ...metricsAuthoringReducer,
  ...AppAdminReducer,
  ...workspaceSettingsModuleReducer,
  ...assignmentDetailsModuleReducer,
  ...LoadSubscribersReducersMapObject,
  ...SetSubscribersReducersMapObject,
  ...LoadSubscribersReducersMapObjectV2,
  ...SetSubscribersReducersMapObjectV2,
  ...rootApiReducer,
  [authoringApi.reducerPath]: authoringApi.reducer,
  [xCardScorecardApi.reducerPath]: xCardScorecardApi.reducer,
  [notificationHubApi.reducerPath]: notificationHubApi.reducer,
  [notificationHubV1Api.reducerPath]: notificationHubV1Api.reducer,
  [ctmApi.reducerPath]: ctmApi.reducer,
};

const rootReducer: Reducer<IStoreState> = combineReducers<IStoreState>(allReducers as any);

export default rootReducer;
